<template>
  <MobileNavIcon>
    <template v-slot:icon>
      <i
        class="text-2xl text-gray-300 hover:text-white sr-2 sr-v2-magnifying-glass"
      />
    </template>

    <template v-slot:content="{ close, isOpen }">
      <div
        class="z-10 flex items-center w-full h-full px-2 md:px-4 bg-gray-1000"
        v-prevent-body-scroll="isMobile && isOpen"
      >
        <Search class="flex-1" @close="close()" :isOpen="isOpen" />
      </div>
    </template>
  </MobileNavIcon>
</template>

<script>
import MobileNavIcon from "@/components/MobileNavIcon";
import Search from "./Search";
import media from "@/mixins/media";

export default {
  mixins: [media],

  components: {
    MobileNavIcon,
    Search,
  },
};
</script>